<template>
  <v-dialog v-model="show" width="500">
    <v-card>
      <v-card-title>
        <span class="headline">{{$t('B1300.buttons.byMonth')}}</span>
      </v-card-title>
      <v-card-actions>
        <v-btn
          :disabled="query.from === null || query.to === null"
          @click="submit"
        >{{$t('app.buttons.export')}}</v-btn>
        <v-btn @click="show=false">{{$t('app.buttons.back')}}</v-btn>
      </v-card-actions>
      <v-card-text>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <remote-autocomplete
                :label="$t('app.labels.group')"
                url="warehouse-groups/kv"
                v-model="query.warehouseGroup"
              />
            </v-flex>
            <v-flex xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2>
                  <date-picker
                    :label="$t('app.labels.forecastAcceptanceDate')"
                    :max="query.to"
                    v-model="query.from"
                  ></date-picker>
                </v-flex>
                <v-flex md6 pl-2>
                  <date-picker :min="query.from" label="~" v-model="query.to"></date-picker>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      show: false,
      query: {},
      resolve: null,
      reject: null
    }
  },
  methods: {
    popup() {
      this.show = true
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    submit() {
      this.show = false
      this.resolve(this.query)
    }
  }
}
</script>
